import { useRouter } from 'next/router';
import { useRef, useEffect, MutableRefObject } from 'react';

type ScrollToElement<T> = {
  ref: MutableRefObject<T | null>;
};

const useScrollToElement = <T extends HTMLElement = HTMLDivElement>(): ScrollToElement<T> => {
  const router = useRouter();
  const ref = useRef<T | null>();

  useEffect(() => {
    if (typeof window === 'undefined') {
      return;
    }

    const refIsOutOfView = ref.current
      && window.scrollY > ref.current.getBoundingClientRect().y;
    if (refIsOutOfView) {
      ref.current.scrollIntoView();
    }
  }, [router.asPath]);

  return { ref };
};

export default useScrollToElement;
